var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{staticClass:"card-height d-flex justify-center text-center flex-column align-center py-1",attrs:{"color":_vm.color}},[_c('div',{staticClass:"text-h6 text-break pb-1 white--text div-font__size"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"text-h5 text-break white--text"},[_vm._v(_vm._s(_vm.text))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }